
import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import RecipeService, { FullData, Recipe } from '@/services/recipes.service';

@Component
export default class IncludeServing extends Vue {
  @Prop() private model!: Recipe;

  updateValue() {
    const value = this.model.include_serving;
    RecipeService.updateOne(this.model.id, {
        include_serving: value,
      }).then((data:FullData) => {
            this.$store.commit('updateRecipe', data.label);
            this.$store.commit('updateTable', data.table);
      }).catch(error => {
        console.log(error);
      });
  }
}
